<template>
    <div class="row">
        <div class="col-md-6">
            <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
                <div class="panel panel-primary heading-border">
                    <div class="panel-heading">
                        <span class="panel-title">
                            <i class="fa fa-pencil-square"></i>
                            <span v-if="client.id">Редактирование клиента</span>
                            <span v-else>Добавление клиента</span>
                        </span>
                    </div>
                    <form @submit.prevent="submit">
                        <div class="panel-body p25">

                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Имя</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.client.firstName.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-tag"></i></label>
                                    </label>
                                    <div v-if="$v.client.firstName.$error === true || forms.client.errors.first_name" class="error">
                                        {{ this.forms.client.errors.first_name ? this.forms.client.errors.first_name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Фамилия</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.client.lastName.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-tag"></i></label>
                                    </label>
                                    <div v-if="$v.client.lastName.$error === true || forms.client.errors.last_name" class="error">
                                        {{ this.forms.client.errors.last_name ? this.forms.client.errors.last_name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row">
                                <div class="col-md-6">

                                    <label class="field-label">Телефон</label>
                                    <label class="field prepend-icon">
                                        <input v-model="$v.client.phone.$model" type="tel" class="gui-input"
                                               placeholder="+7925">
                                        <label class="field-icon">
                                            <i class="fa fa-phone-square"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.client.phone.$error === true || forms.client.errors.phone" class="error">
                                        {{ this.forms.client.errors.phone ? this.forms.client.errors.phone.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">

                                    <label class="field-label">Email</label>
                                    <label class="field prepend-icon">
                                        <input v-model="$v.client.email.$model" type="email" class="gui-input"
                                               placeholder="example@domain.com...">
                                        <label class="field-icon">
                                            <i class="fa fa-envelope"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.client.email.$error === true || forms.client.errors.email" class="error">
                                        {{ this.forms.client.errors.email ? this.forms.client.errors.email.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <!-- end section -->

                            </div>
                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Источник</label>
                                    <label class="field select">
                                        <select v-model="$v.client.source.$model">
                                            <option value="0" disabled="">Выберите источник</option>
                                            <option
                                                    v-for="source in data.sources"
                                                    v-bind:key="source.id"
                                                    :value="source.id"
                                                    :disabled="sourceIsDisabled(source.id)"
                                            >
                                                {{source.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.client.source.$error === true || forms.client.errors.source" class="error">
                                        {{ this.forms.client.errors.source ? this.forms.client.errors.source.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Дата рождения</label>
                                    <label class="field">
                                        <date-picker value-type="format" format="DD.MM.YYYY" v-model="$v.client.birthday.$model" :clearable="false"/>
                                    </label>
                                    <div v-if="$v.client.birthday.$error === true || forms.client.errors.birthday" class="error">
                                        {{ this.forms.client.errors.birthday ? this.forms.client.errors.birthday.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row mb25">
                                <div class="col-md-12">
                                    <label class="field-label">Комментарий</label>
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" v-model="$v.client.comment.$model"></textarea>
                                        <label class="field-icon">
                                            <i class="fa fa-edit"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>


                        </div>
                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary" :disabled="forms.client.isSubmitting">
                                <span v-if="client.id">Сохранить</span>
                                <span v-else>Добавить</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Client from "../../models/Client";
    import { required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';
    import moment from 'moment';

    export default {
        components: {
            datePicker: () => import('vue2-datepicker'),
        },
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {
            if (to.params.id) {
                try {
                    const client = await Client.get(to.params.id);
                    next(component => {
                        component.client = client;
                    });
                } catch (error) {
                    next({
                        name: 'error',
                        path: to.fullPath,
                        params: {
                            code: error.response.status,
                            codeText: error.response.statusText,
                            message: error.response.data.message,
                            trace: error.response.data.type,
                        },
                    })
                }
            } else {
                next(component => {
                    Object.assign(component.$data, component.$options.data.apply(component));
                });
            }
        },
        data() {
            return {
                data: {
                    sources: Client.getSources(),
                },
                client: new Client({
                    birthday: '',
                    firstName: '',
                    lastName: '',
                    phone: '',
                    email: '',
                    comment: '',
                }),
                forms: {
                    client: {
                        isSubmitting: false,
                        errors: {},
                    },
                },
            };
        },
        validations: {
            client: {
                firstName: {required},
                lastName: {},
                phone: {required},
                birthday: {},
                email: {},
                source: {},
                comment: {},
            },
        },
        methods: {
            sourceIsDisabled (id) {
                if (id === Client.SOURCE_GOOGLE_UTM || id === Client.SOURCE_YANDEX_UTM) {
                    return true;
                }
                return false;
            },
            async submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                }

                this.forms.client.isSubmitting = true;
                this.forms.client.errors = {};

                try {
                    if (this.clientBirthday) {
                        this.client.birthday = moment(this.client.birthday, 'DD.MM.YYYY').format('YYYY-MM-DD');
                    }
                    this.client = await this.client.add();

                    await this.$router.push({name: 'clients-edit', params: {id: this.client.id}});
                } catch (error) {
                    this.forms.client.errors = error.errors;
                }

                this.forms.client.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Клиенты - ' + (this.client.id ? 'редактирование' : 'добавление'),
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
